import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200/80 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-950">
                <i className="ri-heart-3-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                红桃<span className="text-primary-500">视频</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              红桃视频是一个高清视频在线观看平台，汇集电影、电视剧、综艺等多类别内容，致力于让每一位观众都能快速找到想看的作品，享受流畅舒适的观影体验。
            </p>
            <div className="mt-5 flex items-center gap-2 text-sm text-foreground-600">
              <span className="w-8 h-8 rounded-md bg-background-200/70 flex items-center justify-center text-primary-400">
                <i className="ri-mail-line text-base" />
              </span>
              <span>service@hongtao-video.example.com</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <span className="inline-flex items-center">
                内容导航
              </span>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link to={cat.path} className="text-foreground-600 hover:text-primary-400 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <span className="inline-flex items-center">
                关于平台
              </span>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  搜索视频
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  意见反馈
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  免责声明
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/80 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© 2026 红桃视频 Hongtao Video · 本网站为演示站点，内容均为虚构示例</p>
          <p>仅供学习与演示使用 · 不提供真实播放与下载服务</p>
        </div>
      </div>
    </footer>
  );
}